module.exports = __webpack_public_path__ + "img/guitarra-2.2f765aac.jpg";